import { render } from "./UsersLists.vue?vue&type=template&id=672ef9b6"
import script from "./UsersLists.vue?vue&type=script&lang=js"
export * from "./UsersLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__